module.exports = __webpack_public_path__ + "static/img/green-1-copy.ef4765c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cronus/green-1-copy.png
// module id = NcKL
// module chunks = 0